export default __webpack_public_path__ + "static/media/1 - Транспорт для катания.11d08f47.jpg";